// extracted by css-extract-rspack-plugin
export default {"root":"Divider-module__root___sIWe1","label":"Divider-module__label___vip9O"};